/**
 * @module ClientConfiguration
 */

import ClientConfigurationCache from './clientConfigurationCache';

/**
 * @enum
 * An enum for the status of the service request
 * @property {number} UnResolved - The request is not made yet
 * @property {number} InProgress - The request is in progress
 * @property {number} Resolved - The request is made and the response is received
 */

export enum ClientConfigurationRequestState {
    UnResolved,
    InProgress,
    Resolved,
}

/**
 * @interface
 * An interface for client configuration in memory
 * @property {ClientConfigurationCache} cache - The client configuration cache object
 * @property {ClientConfigurationRequestState} requestState - The state of the service request
 */

export default interface ClientConfiguration {
    cache: ClientConfigurationCache;
    requestState: ClientConfigurationRequestState;
}
